(function () {
  if (window.NumeoProductImageGalleryInitialized) return;
  window.NumeoProductImageGalleryInitialized = true;

  const GALLERY_SELECTOR = '[data-product-image-gallery]';
  const GAP_FILL_CLASS = 'product-single-media-gap-fill';
  const GAP_FILL_SELECTOR = `.${GAP_FILL_CLASS}`;
  const GAP_FILL_MEDIA_QUERY = window.matchMedia('(min-width: 990px)');
  const GAP_FILL_OFFSET = 32;
  let gapFillFrame = null;

  function updateMediaRatio(galleryRoot, activeSlide) {
    const media = galleryRoot.querySelector('[data-product-gallery-main-media]');
    if (!media || galleryRoot.dataset.galleryHeight !== 'adapt') return;

    const aspectRatio = parseFloat(activeSlide?.dataset.galleryAspectRatio || '');
    if (!Number.isFinite(aspectRatio) || aspectRatio <= 0) return;

    media.style.paddingBottom = `${(1 / aspectRatio) * 100}%`;
  }

  function getSlides(galleryRoot) {
    return Array.from(galleryRoot.querySelectorAll('[data-product-gallery-slide]'));
  }

  function getThumbs(galleryRoot) {
    return Array.from(galleryRoot.querySelectorAll('[data-product-gallery-thumb]'));
  }

  function getTargets(galleryRoot) {
    return getThumbs(galleryRoot)
      .map((thumb) => thumb.dataset.productGalleryTarget)
      .filter(Boolean);
  }

  function getCurrentTarget(galleryRoot) {
    const currentThumb = galleryRoot.querySelector('[data-product-gallery-thumb][aria-current="true"]');
    if (currentThumb?.dataset.productGalleryTarget) return currentThumb.dataset.productGalleryTarget;

    const activeSlide = galleryRoot.querySelector('[data-product-gallery-slide].is-active');
    if (activeSlide?.dataset.productGallerySlide) return activeSlide.dataset.productGallerySlide;

    return getTargets(galleryRoot)[0] || null;
  }

  function getMediaCount(galleryRoot) {
    const mediaCount = parseInt(galleryRoot.dataset.productGalleryMediaCount || '', 10);
    return Number.isFinite(mediaCount) ? mediaCount : getSlides(galleryRoot).length;
  }

  function clearSingleMediaGapFill() {
    document.querySelectorAll(GAP_FILL_SELECTOR).forEach((section) => {
      section.classList.remove(GAP_FILL_CLASS);
      section.style.removeProperty('--product-single-media-pull-up');
      delete section.dataset.productSingleMediaGapFill;
    });
  }

  function getProductSection(galleryRoot) {
    const productInfo = galleryRoot.closest('product-info');
    return productInfo?.closest('.shopify-section') || productInfo;
  }

  function findNextRichTextSection(productSection) {
    let section = productSection?.nextElementSibling;

    while (section) {
      if (section.querySelector?.('.rich-collapsible')) return section;

      const isAnchorSection = section.classList?.contains('anchor-point-section');
      const isEmptySection = section.offsetHeight <= 2 && !section.textContent.trim();

      if (!isAnchorSection && !isEmptySection) return null;

      section = section.nextElementSibling;
    }

    return null;
  }

  function updateSingleMediaGapFill(galleryRoot) {
    if (!galleryRoot || getMediaCount(galleryRoot) !== 1 || !GAP_FILL_MEDIA_QUERY.matches) return;

    const productSection = getProductSection(galleryRoot);
    const targetSection = findNextRichTextSection(productSection);
    const media = galleryRoot.querySelector('[data-product-gallery-main-media]');
    const leftContent = targetSection?.querySelector('.rich-collapsible__left');

    if (!targetSection || !media || !leftContent) return;

    const mediaBottom = media.getBoundingClientRect().bottom + window.scrollY;
    const leftTop = leftContent.getBoundingClientRect().top + window.scrollY;
    const pullUp = Math.max(0, Math.round(leftTop - mediaBottom - GAP_FILL_OFFSET));

    if (pullUp <= 0) return;

    targetSection.style.setProperty('--product-single-media-pull-up', `${pullUp}px`);
    targetSection.classList.add(GAP_FILL_CLASS);
    targetSection.dataset.productSingleMediaGapFill = 'true';
  }

  function updateAllSingleMediaGapFills() {
    clearSingleMediaGapFill();

    document.querySelectorAll(GALLERY_SELECTOR).forEach(updateSingleMediaGapFill);
  }

  function scheduleSingleMediaGapFillUpdate() {
    if (gapFillFrame) window.cancelAnimationFrame(gapFillFrame);

    gapFillFrame = window.requestAnimationFrame(() => {
      gapFillFrame = null;
      updateAllSingleMediaGapFills();
    });
  }

  function updateThumbnailTrack(galleryRoot, target) {
    const track = galleryRoot.querySelector('[data-product-gallery-thumbnail-track]');
    if (!track) return;

    const thumbs = getThumbs(galleryRoot);
    const activeIndex = thumbs.findIndex((thumb) => thumb.dataset.productGalleryTarget === target);
    if (activeIndex < 0) return;

    const itemsPerPage = 3;
    const pageStartIndex = Math.floor(activeIndex / itemsPerPage) * itemsPerPage;
    const firstThumb = thumbs[0];
    const pageThumb = thumbs[pageStartIndex];
    if (!firstThumb || !pageThumb) return;

    track.style.transform = `translateX(-${Math.max(0, pageThumb.offsetLeft - firstThumb.offsetLeft)}px)`;
  }

  function updateDots(galleryRoot, target) {
    const dotsContainer = galleryRoot.querySelector('[data-product-gallery-dots]');
    if (!dotsContainer) return;

    const thumbs = getThumbs(galleryRoot);
    const activeIndex = thumbs.findIndex((thumb) => thumb.dataset.productGalleryTarget === target);

    Array.from(dotsContainer.children).forEach((dot, index) => {
      const active = index === activeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function setActiveImage(galleryRoot, target, initOnly) {
    const slides = getSlides(galleryRoot);
    const thumbs = getThumbs(galleryRoot);
    if (!target || !slides.length || !thumbs.length) return;

    const activeSlide = slides.find((slide) => slide.dataset.productGallerySlide === target);
    if (!activeSlide) return;

    slides.forEach((slide) => {
      const isActive = slide === activeSlide;
      slide.classList.toggle('is-active', isActive);
      slide.hidden = !isActive;
      slide.style.display = isActive ? 'block' : 'none';
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    thumbs.forEach((thumb) => {
      const isActive = thumb.dataset.productGalleryTarget === target;
      thumb.classList.toggle('is-active', isActive);
      if (isActive) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });

    updateMediaRatio(galleryRoot, activeSlide);
    updateDots(galleryRoot, target);
    updateThumbnailTrack(galleryRoot, target);
    scheduleSingleMediaGapFillUpdate();

    if (!initOnly) {
      const activeThumb = thumbs.find((thumb) => thumb.dataset.productGalleryTarget === target);
      activeThumb?.scrollIntoView({ inline: 'nearest', block: 'nearest' });
    }
  }

  function navigateGallery(galleryRoot, direction) {
    const targets = getTargets(galleryRoot);
    if (targets.length < 2) return;

    const currentTarget = getCurrentTarget(galleryRoot);
    let currentIndex = targets.indexOf(currentTarget);
    if (currentIndex < 0) currentIndex = 0;

    const nextIndex =
      direction === 'prev'
        ? (currentIndex - 1 + targets.length) % targets.length
        : (currentIndex + 1) % targets.length;

    setActiveImage(galleryRoot, targets[nextIndex], false);
  }

  function buildDots(galleryRoot) {
    const dotsContainer = galleryRoot.querySelector('[data-product-gallery-dots]');
    if (!dotsContainer || dotsContainer.dataset.productDotsReady === 'true') return;

    const thumbs = getThumbs(galleryRoot);
    dotsContainer.dataset.productDotsReady = 'true';
    dotsContainer.innerHTML = '';

    thumbs.forEach((thumb, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'product-iwt-gallery__dot';
      dot.setAttribute('aria-label', `Bild ${index + 1} anzeigen`);
      dot.addEventListener('click', () => {
        setActiveImage(galleryRoot, thumb.dataset.productGalleryTarget, false);
      });
      dotsContainer.appendChild(dot);
    });
  }

  function initGallery(galleryRoot) {
    if (!galleryRoot || galleryRoot.dataset.productGalleryInitialized === 'true') return;

    const thumbs = getThumbs(galleryRoot);
    if (!thumbs.length) return;

    galleryRoot.dataset.productGalleryInitialized = 'true';
    buildDots(galleryRoot);

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        setActiveImage(galleryRoot, thumb.dataset.productGalleryTarget, false);
      });
    });

    const initialThumb = thumbs.find((thumb) => thumb.hasAttribute('aria-current')) || thumbs[0];
    setActiveImage(galleryRoot, initialThumb.dataset.productGalleryTarget, true);

    galleryRoot.querySelectorAll('img').forEach((image) => {
      if (image.complete) return;
      image.addEventListener('load', scheduleSingleMediaGapFillUpdate, { once: true });
    });
  }

  function initAllGalleries(scope) {
    (scope || document).querySelectorAll(GALLERY_SELECTOR).forEach(initGallery);
  }

  document.addEventListener(
    'click',
    (event) => {
      const previousButton = event.target.closest('[data-product-gallery-prev]');
      if (previousButton) {
        const galleryRoot = previousButton.closest(GALLERY_SELECTOR);
        if (!galleryRoot) return;
        event.preventDefault();
        navigateGallery(galleryRoot, 'prev');
        return;
      }

      const nextButton = event.target.closest('[data-product-gallery-next]');
      if (nextButton) {
        const galleryRoot = nextButton.closest(GALLERY_SELECTOR);
        if (!galleryRoot) return;
        event.preventDefault();
        navigateGallery(galleryRoot, 'next');
      }
    },
    true
  );

  window.addEventListener('resize', () => {
    document.querySelectorAll(GALLERY_SELECTOR).forEach((galleryRoot) => {
      setActiveImage(galleryRoot, getCurrentTarget(galleryRoot), true);
    });
    scheduleSingleMediaGapFillUpdate();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAllGalleries(event.target);
    scheduleSingleMediaGapFillUpdate();
  });

  document.addEventListener('product-info:loaded', (event) => {
    initAllGalleries(event.target);
    scheduleSingleMediaGapFillUpdate();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const sectionRoot = document.getElementById(`MainProduct-${data.sectionId}`);
      let galleryRoot = sectionRoot?.querySelector(GALLERY_SELECTOR);
      const updatedGallery =
        data.html?.getElementById(`MediaGallery-${data.sectionId}`) ||
        data.html?.querySelector(`#MainProduct-${data.sectionId} ${GALLERY_SELECTOR}`) ||
        data.html?.querySelector(GALLERY_SELECTOR);
      const featuredMediaId = data.variant?.featured_media?.id;

      if (galleryRoot && updatedGallery) {
        galleryRoot.replaceWith(updatedGallery);
        galleryRoot = updatedGallery;
        initGallery(galleryRoot);
      }

      if (!galleryRoot || !featuredMediaId) {
        scheduleSingleMediaGapFillUpdate();
        return;
      }

      setActiveImage(galleryRoot, `${data.sectionId}-${featuredMediaId}`, true);
      scheduleSingleMediaGapFillUpdate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllGalleries();
      scheduleSingleMediaGapFillUpdate();
    });
  } else {
    initAllGalleries();
    scheduleSingleMediaGapFillUpdate();
  }

  window.addEventListener('load', () => {
    initAllGalleries();
    scheduleSingleMediaGapFillUpdate();
  });
})();
